/**
 * CDN globals, tools
 */
import { Online } from './globals';

/**  Exports  */
export const CDN_DOMAIN = 'https://cdn.nicejob.co';

export function cdnUrl(input_path: string, adapt_local_port?: number): string {
    const path = input_path[0] === '/' ? input_path.slice(1) : input_path;

    const domain =
        adapt_local_port && !Online ? `http://localhost:${adapt_local_port}` : CDN_DOMAIN;

    return `${domain}/${path}`;
}
